import { Component, OnInit, Input, input, effect, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
    public readonly photoUrl = input<string|undefined>(undefined);
    public readonly name = input<string|undefined>(undefined);
  
    public showInitials = false;
    public initials?: string;

    constructor() {
        effect(() => {
            if(this.name()) this.createInititals();
        });
    }

    ngOnInit() {
        if (!this.photoUrl()) {
            this.showInitials = true;
        }
    }

    private createInititals(): void {
        let initials = "";

        for (let i = 0; i < this.name()!.length; i++) {
            if (this.name()!.charAt(i) === ' ') {
                continue;
            }

            if (this.name()!.charAt(i) === this.name()!.charAt(i).toUpperCase()) {
                initials += this.name()!.charAt(i);

                if (initials.length == 2) {
                    break;
                }
            }
        }

        this.initials = initials;
    }
}